import { SET_MEMBER, CLEAR_MEMBER } from './mutations';

export const actions = {
    setMember({ commit }, payload) {
        commit(SET_MEMBER, payload);
    },
    clearMember({ commit }) {
        commit(CLEAR_MEMBER);
    },
};
